import { render, staticRenderFns } from "./TabJournal.vue?vue&type=template&id=125b4f3d&scoped=true"
import script from "./TabJournal.vue?vue&type=script&lang=js"
export * from "./TabJournal.vue?vue&type=script&lang=js"
import style0 from "./TabJournal.vue?vue&type=style&index=0&id=125b4f3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125b4f3d",
  null
  
)

export default component.exports